<template>
  <v-container fluid class="mt-0 pt-0">

  <div id="surveyCreatorContainer"></div>

  </v-container>
 </template>



<script>
  import { v4 as uuidv4 } from 'uuid';
  import { mapState } from 'vuex';
  import QuizMixins from '@/mixins/QuizMixins.js';
  import * as SurveyKO from 'survey-knockout'
  import * as SurveyCreator from "survey-creator";
  import "survey-creator/survey-creator.css";

  var Survey = SurveyKO;


export default {
  name: 'QuizEdit',

   mixins:[QuizMixins],

   data() {
    return {

    	quizData:"{}",
    	quizId:''


    }


	},


   methods:{


   		async loadCurrentQuiz(){


   				this.quizId = this.$route.params.id; 
   				var currentQuiz = await this.getQuizByID(this.quizId)

   				////console.log(currentQuiz);


   				//determine if we have an existing suveyjs

   				if(currentQuiz.hasOwnProperty('SurveyJS')){

   						this.quizData = JSON.stringify(currentQuiz.SurveyJS);
   				}


   				this.drawSurveyCreator();



   		},


   		drawSurveyCreator(){

   			var vm=this;

        var curStrings = SurveyCreator.localization.getLocale("");
        curStrings.ed.settings = "Quiz Settings";
        curStrings.ed.editSurvey = "Edit Quiz";

			SurveyCreator
			    .StylesManager
			    .applyTheme("stone");

        //SurveyCreator.removeAdorners(["question-actions"]);
        //console.log(SurveyCreator.SurveyQuestionEditorDefinition.definition['dropdown']);
		    //let options = { showEmbededSurveyTab: true };
		    let options = {
		    showLogicTab: false,
        
        showTestSurveyTab:false,
		    showJSONEditorTab: false,
		    showPropertyGrid: false,
		    questionTypes: [
		        "radiogroup"
		    ],
		    pageEditMode: "single",
		    showTitlesInExpressions: true,
		    allowEditExpressionsInTextEditor: false,
		    showTitlesInExpressions: false,
		    allowControlSurveyTitleVisibility: false,
		    showSurveyTitle: "always",
		    	haveCommercialLicense: true,
		    		isAutoSave:true
			};	

    





		     Survey.Serializer.removeProperty("survey", "logo");
		    Survey.Serializer.findProperty("page", "title").visible = false;
		    Survey.Serializer.findProperty("page", "description").visible = false;
		    Survey.settings.allowShowEmptyTitleInDesignMode = false;
		    Survey.settings.allowShowEmptyDescriptionInDesignMode = false;
        Survey.settings.disableOnGettingChoicesFromWeb = true;

        /* kept for future reference
        Survey.Serializer.findProperty("survey", "pages").visible = false;



         Survey.Serializer.findProperty("survey", "logoHeight").visible = false;
          Survey.Serializer.findProperty("survey", "logoWidth").visible = false;
          Survey.Serializer.findProperty("survey", "logoFit").visible = false;
           Survey.Serializer.findProperty("survey", "logoPosition").visible = false;
            Survey.Serializer.findProperty("survey", "cookieName").visible = false;
          Survey.Serializer.findProperty("survey", "mode").visible = false;
          Survey.Serializer.findProperty("survey", "locale").visible = false;



          Survey.Serializer.findProperty("survey", "showProgressBar").visible = false;
          Survey.Serializer.findProperty("survey", "progressBarType").visible = false;

          Survey.Serializer.findProperty("survey", "pagePrevText").visible = false;
          Survey.Serializer.findProperty("survey", "pageNextText").visible = false;

          Survey.Serializer.findProperty("survey", "completeText").visible = false;
          Survey.Serializer.findProperty("survey", "previewText").visible = false;
          Survey.Serializer.findProperty("survey", "startSurveyText").visible = false;
          Survey.Serializer.findProperty("survey", "editText").visible = false;
          Survey.Serializer.findProperty("survey", "requiredText").visible = false;
          Survey.Serializer.findProperty("survey", "goNextPageAutomatic").visible = false;       
          Survey.Serializer.findProperty("survey", "questionsOnPageMode").visible = false;    
          Survey.Serializer.findProperty("survey", "firstPageIsStarted").visible = false; 

          Survey.Serializer.findProperty("survey", "showNavigationButtons").visible = false; 
          Survey.Serializer.findProperty("survey", "showPreviewBeforeComplete").visible = false; 

          Survey.Serializer.findProperty("survey", "showPrevButton").visible = false; 
          Survey.Serializer.findProperty("survey", "showPageTitles").visible = false;   
          Survey.Serializer.findProperty("survey", "showPageNumbers").visible = false;  

          Survey.Serializer.findProperty("survey", "triggers").visible = false;  
          Survey.Serializer.findProperty("survey", "calculatedValues").visible = false;     


          Survey.Serializer.findProperty("survey", "questionStartIndex").visible = false;  
          Survey.Serializer.findProperty("survey", "questionTitlePattern").visible = false;        
          Survey.Serializer.findProperty("survey", "questionTitleTemplate").visible = false;   

          Survey.Serializer.findProperty("survey", "maxTextLength").visible = false; 
          Survey.Serializer.findProperty("survey", "maxOthersLength").visible = false; 
          Survey.Serializer.findProperty("survey", "focusFirstQuestionAutomatic").visible = false; 
          Survey.Serializer.findProperty("survey", "focusOnFirstError").visible = false; 

          Survey.Serializer.findProperty("survey", "questionTitleLocation").visible = false; 
          Survey.Serializer.findProperty("survey", "questionDescriptionLocation").visible = false; 
          Survey.Serializer.findProperty("survey", "questionErrorLocation").visible = false;             

          Survey.Serializer.findProperty("survey", "showQuestionNumbers").visible = false; 
          Survey.Serializer.findProperty("survey", "questionsOrder").visible = false; 


          Survey.Serializer.findProperty("survey", "showTimerPanel").visible = false; 
          Survey.Serializer.findProperty("survey", "showTimerPanelMode").visible = false; 
          */
          //hide all survey properties since we want most of them hidden. we will make the ones we want visible.
          /*for(var x in Survey.Serializer.classes.survey.properties){
            
            ////console.log(Survey.Serializer.classes.survey.properties[x].name)
           Survey.Serializer.findProperty("survey", Survey.Serializer.classes.survey.properties[x].name).visible = false; 
           ////console.log('survey.' + Survey.Serializer.classes.survey.properties[x].name)


          }



          Survey.Serializer.findProperty("survey", "title").visible = true 
          Survey.Serializer.findProperty("survey", "description").visible = true; 
          Survey.Serializer.findProperty("survey", "maxTimeToFinish").visible = true; 
          Survey.Serializer.findProperty("survey", "maxTimeToFinishPage").visible = true;*/
          var maxVisibleIndex = 0;
          function showTheProperty(className, propertyName, visibleIndex) {
              if (!visibleIndex) visibleIndex = ++maxVisibleIndex;
              else {
                  if (visibleIndex > maxVisibleIndex) maxVisibleIndex = visibleIndex;
              }
              //Use Survey Serializer to find the property, it looks for property in the class and all it's parents
              var property = Survey.Serializer.findProperty(className, propertyName);
              if (!property) return;
              property.visibleIndex = visibleIndex;
              //Custom JavaScript attribute that we will use in onShowingProperty event
              property.showProperty = true;
          }
          

          showTheProperty('survey', 'title');
          showTheProperty('survey', 'description');
          showTheProperty('survey', 'maxTimeToFinish');
          showTheProperty('survey', 'maxTimeToFinishPage');
          Survey.Serializer.findProperty("survey", "maxTimeToFinishPage").displayName = 'Max Time Per Question';

          showTheProperty('question', 'name');
          showTheProperty('question', 'title');
          showTheProperty('question', 'description');
          showTheProperty('question', 'correctAnswer');

          showTheProperty('selectbase', 'choices');

          Survey.Serializer.findProperty("question", "name").visible = true;
          Survey.Serializer.findProperty("question", "title").visible = true;
          Survey.Serializer.findProperty("question", "description").visible = true;
          //Survey.Serializer.findProperty("question", "defaultValue").visible = true;
          Survey.Serializer.findProperty("question", "correctAnswer").visible = true;








    this.surveyCreator = new SurveyCreator.SurveyCreator(
      null,
      options
    );

this.surveyCreator.onElementAllowOperations.add(function (sender, options) {
    let obj = options.obj;
    if (!obj || !obj.page) return;

    if (obj.getType() == 'radiogroup') {
      options.allowAddToToolbox = false;
      options.allowChangeRequired = false;
      options.allowChangeType = false;
      options.allowCopy = false;
      options.allowDelete = true;
      options.allowDragging = false;
      options.allowEdit = false;
      options.allowShowHideTitle = false;
    }
   
});

    

  this.surveyCreator.onShowingProperty.add(function(sender, options) {
  console.log("OPTIONS", options);
    if (options.obj.getType().indexOf("validator") > -1) {
        options.canShow = true;
        return;
    }
    if(options.property.name == "validators" && options.obj.getType() != "text"){
        options.canShow = false;
        return;
    }
    options.canShow = options.property.showProperty === true;
});

this.surveyCreator.showPropertyGrid = "right";

this.surveyCreator.onElementAllowOperations.add(function (sender, options) {


});

console.log("QUESTION PROPS");
console.log(SurveyCreator
    .SurveyQuestionEditorDefinition);








	    this.surveyCreator.saveSurveyFunc = function() {
	    	vm.saveQuiz(vm.quizId,this.text);
	    };


this.surveyCreator.render("surveyCreatorContainer");
this.surveyCreator.text = this.quizData;

   }





   },




  mounted() {
 		this.loadCurrentQuiz();
/*
SurveyCreator
    .StylesManager
    .applyTheme("stone");

    //let options = { showEmbededSurveyTab: true };
    let options = {
    showLogicTab: false,
    showJSONEditorTab: false,
    showPropertyGrid: false,
    questionTypes: [
        "radiogroup"
    ],
    pageEditMode: "single",
    showTitlesInExpressions: true,
    allowEditExpressionsInTextEditor: false,
    showTitlesInExpressions: false,
    allowControlSurveyTitleVisibility: false,
    showSurveyTitle: "always",
    	haveCommercialLicense: true
	};	



    Survey.Serializer.removeProperty("survey", "logo");
    Survey.Serializer.findProperty("page", "title").visible = false;
    Survey.Serializer.findProperty("page", "description").visible = false;
    Survey.settings.allowShowEmptyTitleInDesignMode = false;
    Survey.settings.allowShowEmptyDescriptionInDesignMode = false;


    this.surveyCreator = new SurveyCreator.SurveyCreator(
      "surveyCreatorContainer",
      options
    );



this.surveyCreator.onShowingProperty.add(function (sender, options) {
    //console.log('showin properties')
	//console.log(options)

});



    this.surveyCreator.saveSurveyFunc = function() {
      //console.log(JSON.stringify(this.text));
    };*/
  }}




</script>

